import { render, staticRenderFns } from "./server-stats.vue?vue&type=template&id=73b52f2a"
import script from "./server-stats.vue?vue&type=script&lang=js"
export * from "./server-stats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports